import React, {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {requestPassword} from '../core/_requests'
import {forgotPassword} from '../../../../api/modules/auth'
import {Form} from 'react-bootstrap'
import {useTranslation, initReactI18next} from 'react-i18next'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import swal from 'sweetalert'

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)

  const {t} = useTranslation()

  const [userMail, setUserMail] = useState('')

  const sendForgotPass = async () => {
    await forgotPassword({email: userMail})
      .then((res) => {
        swal({
          icon: 'success',
          title: res.data.message,
        })
        // alert(res.data.message)
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            icon: 'error',
            title: error.response.data.message,
          })
          // alert(error.response.data.message)
        }
      })
  }

  return (
    <>
      <div id='auth'>
        <div className='test'>
          <img className='image' src={toAbsoluteUrl(`/media/login-page.png`)} />
          <div className='text'>
            <img className='me-5' src={toAbsoluteUrl(`/media/bumn.svg`)} />
            <img src={toAbsoluteUrl(`/media/pi.svg`)} />
          </div>
        </div>
        <div className='sectionFormAuth'>
          <img src={toAbsoluteUrl(`/media/andalan-logo.svg`)} style={{marginLeft: '-1rem'}} />
          <h1 className='fw-normal mb-3 mt-1'>{t('Forgot Password')}</h1>
          <h2 className='fw-normal mb-8'>{t('reset-password')}</h2>

          {hasErrors === true && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>{t('errors detected')}</div>
            </div>
          )}

          {hasErrors === false && (
            <div className='mb-10 bg-light-info p-8 rounded'>
              <div className='text-info'>{t('Sent password')}</div>
            </div>
          )}

          <div className='fv-row mb-10'>
            <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
            <Form.Control
              type='email'
              placeholder='email'
              autoComplete='off'
              className={clsx('form-control form-control-lg form-control-solid')}
              onChange={(e: any) => setUserMail(e.target.value)}
            />
          </div>

          <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
            <Link to='/auth/login'>
              <button
                type='button'
                id='kt_login_password_reset_form_cancel_button'
                className='btn btn-secondary fw-bolder me-2'
              >
                {t('cancel')}
              </button>
            </Link>{' '}
            <button
              type='submit'
              onClick={() => sendForgotPass()}
              id='kt_password_reset_submit'
              className='btn fw-bolder'
              style={{backgroundColor: '#274070'}}
            >
              <span className='indicator-label text-white'>{t('submit')}</span>
              {loading && (
                <span className='indicator-progress'>
                  {t('Please wait')}...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>

          {/* <form onSubmit={sendForgotPass} className='formAuth'>
            <div className='fv-row mb-10'>
              <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
              <Form.Control

                placeholder='email'
                autoComplete='off'
                className={clsx('form-control form-control-lg form-control-solid')}
                onChange={(e: any) => setUserMail(e.target.value)}
              />
            </div>

            <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
              <Link to='/auth/login'>
                <button
                  type='button'
                  id='kt_login_password_reset_form_cancel_button'
                  className='btn btn-secondary fw-bolder me-2'
                >
                  {t('cancel')}
                </button>
              </Link>{' '}
              <button
                type='submit'
                onClick={() => sendForgotPass()}
                id='kt_password_reset_submit'
                className='btn fw-bolder'
                style={{ backgroundColor: '#274070' }}
              >
                <span className='indicator-label text-white'>{t('submit')}</span>
                {loading && (
                  <span className='indicator-progress'>
                    {t('Please wait')}...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </form> */}
        </div>
      </div>
      {/* <div className='text-center mb-10'>

        <h1 className='text-dark mb-3'>Forgot Password ?</h1>

        <div className='text-gray-400 fw-bold fs-4'>Enter your email to reset your password.</div>

      </div>

      {hasErrors === true && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>
            Sorry, looks like there are some errors detected, please try again.
          </div>
        </div>
      )}

      {hasErrors === false && (
        <div className='mb-10 bg-light-info p-8 rounded'>
          <div className='text-info'>Sent password reset. Please check your email</div>
        </div>
      )}

      <form onSubmit={sendForgotPass}>
        <div className='fv-row mb-10'>
          <Form.Control

            placeholder='email'
            autoComplete='off'
            onChange={(e: any) => setUserMail(e.target.value)}
          />
        </div>

        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <button
            type='submit'
            onClick={() => sendForgotPass()}
            id='kt_password_reset_submit'
            className='btn btn-lg btn-primary fw-bolder me-4'
          >
            <span className='indicator-label'>{t('submit')}</span>
            {loading && (
              <span className='indicator-progress'>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-lg btn-light-primary fw-bolder'
            >
              Cancel
            </button>
          </Link>{' '}
        </div>
      </form> */}
    </>
  )
}
